export default "__VITE_ASSET__DUtgWXkl__"